// extracted by extract-css-chunks-webpack-plugin
module.exports = {"price":"_5KL4c","discountMessage":"zmypl","sticky":"Rpj0B"};